// extracted by css-extract-rspack-plugin
export default {"ImageCard":"Ath6d","UpsellCta":"yOUa3"};